import { CUSTOMER_DEFAULT_TAG_COLOR } from '@super-mega/server/contracts/customer'
import { TagColorPicker, type TagColorPickerProps } from '@/components/tag-color-picker.tsx'
import { CUSTOMER_TAG_COLOR_PRESETS, CUSTOMER_TAG_PRESETS } from '../const/customer-tag-color-picker.ts'

export function CustomerTagColorPicker(props: Pick<TagColorPickerProps, 'value' | 'onChange'>) {
  return (
    <TagColorPicker
      {...props}
      defaultColor={CUSTOMER_DEFAULT_TAG_COLOR}
      colors={CUSTOMER_TAG_COLOR_PRESETS}
      presets={CUSTOMER_TAG_PRESETS}
    />
  )
}
